import { render, staticRenderFns } from "./projects.html?vue&type=template&id=c5657456&"
import script from "./projects.js?vue&type=script&lang=js&"
export * from "./projects.js?vue&type=script&lang=js&"
import style0 from "./projects.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports